export enum SortType {
  Relevance = 'relevance',
  PriceLow2High = 'priceLow2High',
  PriceHigh2Low = 'priceHigh2Low',
}
